import { BaseConnection } from "./connection";
import { NameExternalEvidence, NameInternalEvidence } from "./nameEvidence";
import { Place } from "./place";
import { Version } from "./version";

export enum SystemContributorTypes {
  TRANSLATOR = "translator",
  REVEALER = "revealer",
  CONCEALER = "concealer",
  COMMISSIONER = "commissioner",
  PETITIONER = "petitioner",
  SCRIBE = "scribe",
  PATRON = "patron",
  ANNOTATOR = "annotator",
  AUTHOR = "author",
}
export const SYSTEM_CONTRIBUTION_TYPES_LABELS: Record<
  SystemContributorTypes,
  string
> = {
  [SystemContributorTypes.TRANSLATOR]: "Translator",
  [SystemContributorTypes.REVEALER]: "Revealer",
  [SystemContributorTypes.CONCEALER]: "Concealer",
  [SystemContributorTypes.COMMISSIONER]: "Commissioner",
  [SystemContributorTypes.PETITIONER]: "Petitioner",
  [SystemContributorTypes.SCRIBE]: "Scribe",
  [SystemContributorTypes.PATRON]: "Patron",
  [SystemContributorTypes.ANNOTATOR]: "Annotator",
  [SystemContributorTypes.AUTHOR]: "Author",
};

export type ContributorConnection = BaseConnection & {
  system_contribution_type: SystemContributorTypes;
  name?: string;
  status?: string;
  system_language_type: Version["system_language_type"];
  name_internal_evidence: NameInternalEvidence;
  name_external_evidence: NameExternalEvidence;
  role?: string;
  place_id?: string | null;
  place_identification_status: string;
  place: Place | null;
};
